var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('waiting-modal',{attrs:{"title":_vm.title,"status":_vm.status,"active":_vm.active_waiting},on:{"statusdailog":_vm.update_status_wait}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }